import React, { FC } from "react";
import { queryCache } from "react-query";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import AddStudentDark from "../../../../assets/svg/add-inside-circle-dark.svg";
import AddStudent from "../../../../assets/svg/add-inside-circle.svg";
import Loading from "../../../../components/Loading";
import { useWizard } from "../../../wizard/context";
import { useManagedStudentsPage } from "../../context/managedStudentsPageContext";
import { useAddStudentConfig } from "../../modals/hooks/useAddStudentConfig";
import { StudentListItem } from "./StudentListItem";

const useStyles = makeStyles(() => ({
  root: {
    padding: "24px 16px",
    width: 732,
    minHeight: 245,
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 8px #C2C9D682",
    borderRadius: 15,
    position: "relative",
    overflow: "hidden",
  },
  loading: {
    position: "absolute",
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#231F20",
    paddingLeft: 8,
  },
  studentsCont: {
    marginTop: 30,
  },
  addStudentCont: {
    display: "flex",
    justifyContent: "center",
  },
  addStudent: {
    borderRadius: "50%",
    width: 76,
    height: 76,
    backgroundImage: `url(${AddStudent})`,
    "&:hover": {
      boxShadow: "0px 0px 8px #C2C9D6B3",
      backgroundImage: `url(${AddStudentDark})`,
      cursor: "pointer",
    },
  },
}));

const FilterResults: FC = () => {
  const classes = useStyles();
  const { loading, students = [] } = useManagedStudentsPage();
  const { openWizard } = useWizard();

  const getAddStudentConfig = useAddStudentConfig();

  const addStudent = async () => {
    if (await openWizard(getAddStudentConfig.getAddStudentConfig())) {
      await queryCache.invalidateQueries();
    }
  };

  return (
    <div className={classes.root}>
      {!!loading && <Loading className={classes.loading} />}
      <Typography className={classes.title} component={"h2"}>
        Students
      </Typography>
      <Grid container spacing={1} className={classes.studentsCont}>
        <Grid item md={2} sm={2} xs={2}>
          <div className={classes.addStudentCont}>
            <div className={classes.addStudent} onClick={addStudent} />
          </div>
        </Grid>
        {students.map((student) => (
          <Grid key={student.id} item md={2} sm={2} xs={2}>
            <StudentListItem
              id={student.id}
              name={student.name}
              country={student.country}
              photo={student.photo}
              status={student.status}
              hasNewMessage={student.hasNewMessage}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default React.memo(FilterResults);
